import { render } from "./MobileAndTabletMenu.vue?vue&type=template&id=3740ac6b&scoped=true"
import script from "./MobileAndTabletMenu.vue?vue&type=script&lang=js"
export * from "./MobileAndTabletMenu.vue?vue&type=script&lang=js"

import "./MobileAndTabletMenu.vue?vue&type=style&index=0&id=3740ac6b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3740ac6b"]])

export default __exports__